export default __webpack_public_path__ + "static/media/taiko-large.e94c7293.svg";